import { render, staticRenderFns } from "./BiographySection.vue?vue&type=template&id=777b3de2"
import script from "./BiographySection.vue?vue&type=script&lang=js"
export * from "./BiographySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports